import { FC } from 'react';
import { Link } from 'react-router-dom';
import { MainRoutes } from '@/config/route.config';

import "./HomeLandingPage.css";

type NavItem = { label: string; to: string };

const HomeLandingPage: FC = () => {
  const navItems: NavItem[] = [
    { label: "Policy Status Update *", to: MainRoutes.POLICY_STATUS_UPDATE },
    { label: "Policy Num Update *", to: MainRoutes.POLICY_NUMBER_UPDATE },
    { label: "Upload Signatures *", to: MainRoutes.UPLOAD_SIGNATURE },
    { label: "Form Utility *", to: MainRoutes.FORM_UTILITY },
    { label: "UpdateUnderwriter *", to: MainRoutes.UPDATE_UNDER_WRITER },
    { label: "Data Script Run UI *", to: MainRoutes.UPDATE_INVOICE_STATUS }
    
  ];

  return (
    <article className="home">
      {/* Page header (optional; safe if you already have a global header) */}
      <header className="home__header">
        <h1 className="home__title">CDP Operations</h1>
        <p className="home__subtitle">Quick access to frequently used utilities</p>
      </header>

      {/* Navigation grid */}
      <nav className="home__grid" aria-label="Available utilities">
        <ul className="home__grid-list">
          {navItems?.map((item, index) => {
            const hasRequiredAsterisk = /\*\s*$/.test(item.label);
            const cleanLabel = item.label.replace(/\s*\*$/, '').trim();

            return (
              <li className="home__grid-item" key={`nav-item-${index}`}>
                <Link
                  className="tile"
                  to={item.to}
                  aria-label={`Open ${cleanLabel}`}
                >
                  <span className="tile__text">
                    <span className="tile__label">{cleanLabel}</span>
                    {hasRequiredAsterisk && (
                      <sup className="tile__required" aria-label="required"></sup>
                    )}
                  </span>
                  <span className="tile__chevron" aria-hidden="true"></span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </article>
  );
};

export default HomeLandingPage;
